import axios from 'axios';

export const wirelessAuth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export async function loadWirelessTargets(siteId) {
  const response = await axios.get(`/api/site-control/sites/${siteId}`, wirelessAuth());
  return (response.data?.targets || []).filter((target) => target.adb?.authMode === 'tls');
}

export function wirelessTargetForDevice(targets, deviceId) {
  return targets.find((target) => Number(target.deviceId) === Number(deviceId))
    || targets.find((target) => Number(target.linkedDeviceId) === Number(deviceId));
}

export function wirelessRecoveryMessage(result) {
  if (result.status === 'already_connected') return 'Wireless Debugging is already connected; no keys were sent.';
  if (result.status === 'verified') return 'Wireless Debugging connected — ADB responded successfully.';
  if (result.status === 'checkpoint_failed') return 'Recovery stopped at a checkpoint. Check the device and the saved training routine.';
  return 'Recovery keys sent. Waiting for ADB to reconnect; connection status will update after a successful check.';
}
